// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ClosuresManagerList    = lazy(() => import('../../views/closures/manager/list'))
const ClosuresManagerEdit    = lazy(() => import('../../views/closures/manager/edit'))
const ClosuresManagerPrint   = lazy(() => import('../../views/closures/manager/print'))
const ClosuresManagerPreview = lazy(() => import('../../views/closures/manager/preview'))

const ClosuresManager = [
  {
    path: '/closures/manager/list',
    element: <ClosuresManagerList />
  },
  {
    path: '/closures/manager/edit/:id',
    element: <ClosuresManagerEdit />
  },
  {
    path: '/closures/manager/print/:id',
    element: <ClosuresManagerPrint />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/closures/manager/preview/:id',
    element: <ClosuresManagerPreview />
  }
]

export default ClosuresManager
